// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606020803/js/" + chunkId + "." + {"44":"91ee32a0","225":"d0aae976","481":"ab8390d9","486":"9bb48935","770":"1de7f851"}[chunkId] + ".0.45920754119728224.chunk.js";
};